// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#defaultRTE .e-rte-content {
    min-height: 50vh;
}


.e-rte-code-mirror-enabled .rte-code-mirror {
    display: block !important;
    /* To show the custom source code view. */
}

.e-rte-code-mirror-enabled .e-rte-content {
    display: none !important;
    /* To hide the editor area when custom source code enabled. */
}

/** Mention template styles **/
.editor-mention-item-template {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.editor-mention-item-template .em-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.editor-mention-item-template .em-avatar {
    width: 32px;
    height: 32px;
    text-align: center;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 500;
    text-indent: 0px;
    line-height: 13px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.editor-mention-item-template .em-name {
    color: rgb(16, 24, 40);
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    margin-bottom: 5px;
}

.editor-mention-item-template .em-email {
    color: gray;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
}

#toolsRTE_rte-edit-view_options li {
    padding: 10px;
    height: 60px;
}

body[class*="-dark"] .em-name {
    color: #fff !important;
}

/** custom source code styles **/
body[class*="-dark"] .rte-code-mirror .cm-tag {
    color: #00ff00;
}

body[class*="-dark"] .rte-code-mirror .cm-string {
    color: blue;
}

body[class*="-dark"] .rte-code-mirror .cm-attribute {
    color: #f00;
}

body[class*="-dark"] .rte-code-mirror .CodeMirror-gutters,
body[class*="-dark"] .rte-code-mirror .CodeMirror {
    background-color: transparent;
    color: #fff;
}

.sb-header {
    z-index: 100;
}

.sb-content.e-view.hide-header {
    top: 0 !important;
}

.sb-header.e-view.hide-header {
    display: none;
}




.e-file-container .e-upload-fails {
    display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Editor/index.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;;AAGA;IACI,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;IACxB,6DAA6D;AACjE;;AAEA,8BAA8B;AAC9B;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,gCAAgC;AAChC;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;;;;AAKA;IACI,wBAAwB;AAC5B","sourcesContent":["#defaultRTE .e-rte-content {\n    min-height: 50vh;\n}\n\n\n.e-rte-code-mirror-enabled .rte-code-mirror {\n    display: block !important;\n    /* To show the custom source code view. */\n}\n\n.e-rte-code-mirror-enabled .e-rte-content {\n    display: none !important;\n    /* To hide the editor area when custom source code enabled. */\n}\n\n/** Mention template styles **/\n.editor-mention-item-template {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.editor-mention-item-template .em-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.editor-mention-item-template .em-avatar {\n    width: 32px;\n    height: 32px;\n    text-align: center;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: 500;\n    text-indent: 0px;\n    line-height: 13px;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.editor-mention-item-template .em-name {\n    color: rgb(16, 24, 40);\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 14px;\n    margin-bottom: 5px;\n}\n\n.editor-mention-item-template .em-email {\n    color: gray;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 14px;\n}\n\n#toolsRTE_rte-edit-view_options li {\n    padding: 10px;\n    height: 60px;\n}\n\nbody[class*=\"-dark\"] .em-name {\n    color: #fff !important;\n}\n\n/** custom source code styles **/\nbody[class*=\"-dark\"] .rte-code-mirror .cm-tag {\n    color: #00ff00;\n}\n\nbody[class*=\"-dark\"] .rte-code-mirror .cm-string {\n    color: blue;\n}\n\nbody[class*=\"-dark\"] .rte-code-mirror .cm-attribute {\n    color: #f00;\n}\n\nbody[class*=\"-dark\"] .rte-code-mirror .CodeMirror-gutters,\nbody[class*=\"-dark\"] .rte-code-mirror .CodeMirror {\n    background-color: transparent;\n    color: #fff;\n}\n\n.sb-header {\n    z-index: 100;\n}\n\n.sb-content.e-view.hide-header {\n    top: 0 !important;\n}\n\n.sb-header.e-view.hide-header {\n    display: none;\n}\n\n\n\n\n.e-file-container .e-upload-fails {\n    display: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
